import { FC } from "react";
import { IconProps } from "./types";

export const SocialInstagram: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.997 14.866a2.868 2.868 0 0 1-2.862-2.865A2.866 2.866 0 0 1 12 9.138a2.866 2.866 0 0 1 2.863 2.864 2.867 2.867 0 0 1-2.866 2.864zM12 7.59a4.41 4.41 0 0 0-4.414 4.413 4.416 4.416 0 0 0 4.4 4.413A4.413 4.413 0 1 0 12 7.59z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.039 13.457c0 .467-.009.934-.02 1.402-.008.297-.023.595-.044.893a4.62 4.62 0 0 1-.234 1.197 2.864 2.864 0 0 1-1.814 1.803c-.25.086-.507.148-.77.18-.246.03-.494.05-.742.064-1.138.062-2.278.044-3.417.041-.742 0-1.485.005-2.227-.002a33.77 33.77 0 0 1-1.264-.04 5.683 5.683 0 0 1-1.14-.156c-.83-.206-1.477-.66-1.9-1.413a3.343 3.343 0 0 1-.346-.972c-.071-.34-.1-.684-.117-1.03-.066-1.355-.045-2.71-.047-4.064-.001-.639.005-1.278.016-1.917.005-.355.021-.711.042-1.068.026-.443.092-.878.234-1.299a2.83 2.83 0 0 1 1.29-1.589c.315-.183.66-.292 1.016-.366a6.72 6.72 0 0 1 1.034-.115 46.047 46.047 0 0 1 2.41-.045c1.06 0 2.121 0 3.181.008.436.003.87.021 1.305.04.399.018.794.063 1.18.164.846.219 1.492.694 1.903 1.472.166.313.265.652.33 1 .07.373.091.75.106 1.128.06 1.562.037 3.123.035 4.684zm1.514-4.71a13.18 13.18 0 0 0-.07-.962c-.078-.714-.268-1.4-.633-2.026a4.323 4.323 0 0 0-2.3-1.93 5.395 5.395 0 0 0-1.276-.305c-.3-.031-.6-.055-.9-.07-1.521-.071-3.043-.039-4.565-.042a55.876 55.876 0 0 0-1.58.019c-.369.009-.736.025-1.103.05-.697.049-1.374.188-2.008.486-1.092.51-1.853 1.334-2.282 2.461a5.65 5.65 0 0 0-.307 1.235 11 11 0 0 0-.079.96c-.066 1.459-.038 2.916-.041 4.375 0 .59.006 1.18.02 1.771.007.373.025.745.052 1.116a5.85 5.85 0 0 0 .45 1.93c.22.507.53.952.922 1.343.38.377.81.68 1.299.896.382.168.777.295 1.189.364.253.042.507.077.763.101.235.024.474.032.71.039.398.013.797.02 1.196.03l.034.006h3.911l.266-.008c.472-.016.945-.025 1.417-.047a6.548 6.548 0 0 0 1.437-.215c1.482-.409 2.524-1.313 3.087-2.751.149-.379.24-.773.3-1.175.05-.34.072-.682.087-1.025.074-1.76.037-3.521.039-5.282 0-.447-.016-.895-.035-1.344z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.585 6.383a1.032 1.032 0 1 0 .001 2.064 1.032 1.032 0 0 0 0-2.063z"
      fill={fill}
    />
  </svg>
);
